export default __webpack_public_path__ + "static/media/web_3_4.38bb0349.png";